let scrollY: number

const isScrollLocked = () => document.body.classList.contains('scroll-locked')

export const lockScroll = () => {
  scrollY = window.scrollY
  document.body.classList.add('scroll-locked')
}

export const unlockScroll = () => {
  if (!isScrollLocked()) return

  document.body.classList.remove('scroll-locked')
  window.scrollTo(0, scrollY)
}
